'use client';

import React, { FC, useState } from 'react';
import Input from 'components/commercetools-ui/atoms/input';
import Button from 'components/commercetools-ui/atoms/button';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';
import { useFormat } from 'helpers/hooks/useFormat';
import { useAfd } from 'frontastic';

const AfdComponent: React.FC<any> = ({ callToParent }) => {
  const { getAddressList, getAddressDetails } = useAfd();
  const [postCode, setPostCode] = useState({ postCode: '' });
  const [addressList, setAddressList] = useState([]);
  const [responseError, setResponseError] = useState('');
  const [selectMsg, setSelectMsg] = useState('');

  const { formatMessage } = useFormat({ name: 'common' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPostCode({ ...postCode, [e.target.name]: e.target.value });
  };
  const handleChangeAddress = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    loadAddressDetails(e.target.value);
  };
  const loadAddress = async () => {
    const response: any = await getAddressList(postCode.postCode);
    if (!response['ErrorText']) {
      const updatedArray = response['Item'].map((item: any) => {
        // Remove the postcode from the beginning of the 'List' attribute
        const listWithoutPostcode = item.List.replace(item.Postcode, '').trim();
        return {
          ...item,
          List: `${listWithoutPostcode}, ${item.Postcode}`,
        };
      });
      setAddressList(updatedArray);
      setResponseError('');
      setSelectMsg(formatMessage({ id: 'select.an.address', defaultMessage: 'Now please select an address.' }));
    } else {
      setAddressList([]);
      setSelectMsg('');
      if (response['Result']) {
        setResponseError(
          response['Result'] == -2
            ? formatMessage({
                id: 'zipCode.enter.valid.postcode',
                defaultMessage: 'We were unable to find this postcode.  Please check the postcode provided.',
              })
            : response['Result'] == -5
            ? formatMessage({ id: 'service.unavailable', defaultMessage: 'Service unavailable' })
            : response['ErrorText'],
        );
      }
    }
  };
  const loadAddressDetails = async (key: string) => {
    if (!key) return;
    setSelectMsg('');
    const response: any = await getAddressDetails(key);
    if (!response['ErrorText']) {
      if (response && response['Item'].length > 0) {
        const line1 = response['Item'][0].Property ? response['Item'][0].Property : response['Item'][0].Street;
        const line2 = response['Item'][0].Property ? response['Item'][0].Street : '';
        const objAddressDetails = {
          line1: line1,
          line2: line2,
          town: response['Item'][0].Town,
          postcode: response['Item'][0].Postcode,
          postalCounty: response['Item'][0].PostalCounty,
          longitude: response['Item'][0].Longitude,
          latitude: response['Item'][0].Latitude,
        };
        callToParent(objAddressDetails);
      }
    } else {
      setSelectMsg(
        response['Result'] == -5
          ? formatMessage({ id: 'service.unavailable', defaultMessage: 'Service unavailable' })
          : response['ErrorText'],
      );
    }
  };
  const dropdownList =
    addressList.length > 0
      ? [
          { label: formatMessage({ id: 'please.select', defaultMessage: 'Please select' }), value: '' },
          ...addressList.map(({ Key, List }) => ({ label: List, value: Key })),
        ]
      : [];
  return (
    <>
      <div className="col-span-2 lg:col-span-1">
        <Input label="Postcode" id="postCode" name="postCode" type="text" onChange={handleChange} />
        {responseError && <p className="mt-10 text-12 text-accent-red">{responseError}</p>}
      </div>
      <div className="col-span-2 lg:col-span-1">
        <Button
          variant="secondary"
          size="full"
          type="button"
          className="mt-28 text-16 font-medium leading-tight"
          onClick={loadAddress}
        >
          Find Address
        </Button>
      </div>
      <div className="col-span-4 lg:col-span-2">
        <Dropdown
          name="selectAddress"
          items={dropdownList}
          onChange={handleChangeAddress}
          className="w-full border-neutral-500 pr-38 text-16 font-light"
          label={formatMessage({ id: 'select.address', defaultMessage: 'Select address' })}
        />
        {selectMsg && <p className="mt-12 text-12 text-accent-red">{selectMsg}</p>}
      </div>
    </>
  );
};

export default AfdComponent;
